import globalStyles from "../../../../../assets/styles/base/globalPage.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { processRavenPayment } from "../../../../../store/modules/payments";
import {
  ArrowCircle,
  CardPaymentIcon,
  RavenIcon,
} from "../../../../../assets/svgIcons";
import { RoutedModal } from "../../../../common";
import { useState } from "react";
import { TransferListener } from "../TransferListener";
import { useGetCheckoutPaymentProviders } from "../../../../../hooks/useGetCheckoutPaymentProviders";
import Images from "../../../../../assets/images";

export const PaymentViaTransferPrompt = ({
  amount = "",
  closeModal = () => {},
  chargeOutsideApp = () => {},
}) => {
  const dispatch = useDispatch();
  const [isListeningToPayment, setIsListeningToPayment] = useState(false);
  const { business_email } = useSelector(
    (state) => state.profileDetailsReducer.businessDetails,
  );
  const { allowedPaymentProviders } = useGetCheckoutPaymentProviders();

  return (
    <>
      <div>
        {allowedPaymentProviders?.includes("raven") && (
          <div
            className={`${globalStyles.cardWithBorder} cursor-pointer flex-row align-items-center mb-3`}
            style={{ gap: "15px" }}
            onClick={() => {
              dispatch(
                processRavenPayment({
                  business_email,
                  amount: amount,
                  allowFeedBack: false,
                }),
              );
            }}
          >
            <div
              className="d-flex justify-content-center"
              style={{ gap: "10px" }}
            >
              <RavenIcon />
              <div>
                <h6 className="mb-0">Use Raven</h6>
                <p className="small-text-size">
                  Process the payment through Raven. It is connected to your
                  checkout and automatically reconciles payments with your
                  sales.
                </p>
              </div>
            </div>
            <ArrowCircle stroke="#15112D" width="20" height="20" />
          </div>
        )}

        {allowedPaymentProviders?.includes("interswitch") && (
          <div
            className={`${globalStyles.cardWithBorder} cursor-pointer flex-row align-items-center mb-3`}
            style={{ gap: "15px" }}
            onClick={() => {
              setIsListeningToPayment(true);
            }}
          >
            <div
              className="d-flex justify-content-center"
              style={{ gap: "10px" }}
            >
              {/* <RavenIcon /> */}
              <img
                src={Images.interswitch}
                alt={"interswitch"}
                width={40}
                height={40}
                className="rounded mr-2"
              />
              <div>
                <h6 className="mb-0">Use Interswitch SmartPOS</h6>
                <p className="small-text-size">
                  Process the payment through Interswitch SmartPOS. It is
                  connected to your checkout and automatically reconciles
                  payments with your sales.
                </p>
              </div>
            </div>
            <ArrowCircle stroke="#15112D" width="20" height="20" />
          </div>
        )}

        <div
          className={`${globalStyles.cardWithBorder} cursor-pointer flex-row align-items-center`}
          style={{ gap: "15px" }}
          onClick={() => {
            chargeOutsideApp();
            closeModal();
          }}
        >
          <div
            className="d-flex justify-content-center"
            style={{ gap: "10px" }}
          >
            <CardPaymentIcon width="40" height="41" />
            <div>
              <h6 className="mb-0">Transfer payment recieved already</h6>
              <p className="small-text-size">
                If you have already collected the payment before reaching this
                point choose this option.
              </p>
            </div>
          </div>
          <ArrowCircle stroke="#15112D" width="20" height="20" />
        </div>
      </div>

      <RoutedModal
        isActive={isListeningToPayment}
        width={650}
        showHeader={false}
        style={{ height: "auto" }}
      >
        <TransferListener
          amount={amount}
          closeModal={() => setIsListeningToPayment(false)}
        />
      </RoutedModal>
    </>
  );
};
